<mat-toolbar>
  <span>Stats Management</span>
  <span class="spacer"></span>
  <button mat-raised-button color="primary" (click)="startCreate()">
    <mat-icon>add</mat-icon>
    Create Stat Definition
  </button>
</mat-toolbar>

<div class="stats-container">
  @if (isLoading) {
    <div class="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Loading stats...</p>
    </div>
  } @else {
    @if (getCategories().length === 0) {
      <mat-card class="empty-state">
        <mat-card-content>
          <div class="empty-content">
            <mat-icon>analytics</mat-icon>
            <h3>No Stats Defined</h3>
            <p>Create your first stat definition to start tracking data.</p>
            <button mat-raised-button color="primary" (click)="startCreate()">
              <mat-icon>add</mat-icon>
              Create Stat Definition
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    } @else {
      <div class="stats-summary">
        <mat-card>
          <mat-card-content>
            <h3>Overview</h3>
            <p>{{ getTotalStatsCount() }} stat definitions across {{ getCategories().length }} categories</p>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-accordion class="stats-accordion">
        @for (category of getCategories(); track category) {
          <mat-expansion-panel [expanded]="isCategoryExpanded(category)" (openedChange)="onExpansionChange(category, $event)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>folder</mat-icon>
                {{ category }}
              </mat-panel-title>
              <mat-panel-description>
                {{ getTablesForCategory(category).length }} tables
              </mat-panel-description>
            </mat-expansion-panel-header>
            
            <div class="category-actions">
              <button mat-stroked-button (click)="startCreateForCategory(category)" class="add-button">
                <mat-icon>add</mat-icon>
                Add Stat to {{ category }}
              </button>
            </div>

            <div class="category-content">
              @for (table of getTablesForCategory(category); track table) {
                <mat-card class="table-card">
                  <mat-card-header>
                    <mat-card-title>
                      <mat-icon>table_chart</mat-icon>
                      {{ table }}
                    </mat-card-title>
                    <mat-card-subtitle>
                      {{ getStatsForTable(category, table).length }} stats
                    </mat-card-subtitle>
                    <div class="table-actions">
                      <button mat-icon-button (click)="startCreateForTable(category, table)" matTooltip="Add stat to this table">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </mat-card-header>
                  
                  <mat-card-content>
                    <div class="stats-grid">
                      @for (stat of getStatsForTable(category, table); track stat.id) {
                        <div class="stat-item">
                          <div class="stat-header">
                            <div class="stat-info">
                              <h4>{{ stat.key_name }}</h4>
                              <mat-chip-set>
                                <mat-chip [class]="stat.aggregation_type === 'tally' ? 'tally-chip' : 'average-chip'">
                                  {{ stat.aggregation_type }}
                                </mat-chip>
                                @if (stat.aggregation_type === 'average') {
                                  <mat-chip class="submission-chip">
                                    {{ stat.submission_count }} submissions
                                  </mat-chip>
                                }
                              </mat-chip-set>
                            </div>
                            <button mat-icon-button [matMenuTriggerFor]="statMenu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #statMenu="matMenu">
                              <button mat-menu-item (click)="startEdit(stat)">
                                <mat-icon>edit</mat-icon>
                                Edit
                              </button>
                              <button mat-menu-item (click)="resetStatData(stat)">
                                <mat-icon>refresh</mat-icon>
                                Reset Data
                              </button>
                              <button mat-menu-item (click)="deleteDefinition(stat)" class="delete-action">
                                <mat-icon>delete</mat-icon>
                                Delete
                              </button>
                            </mat-menu>
                          </div>

                          <div class="stat-value">
                            <div class="value-display">
                              <span class="current-value">{{ stat.current_value | number:'1.2-4' }}</span>
                              <span class="value-range">({{ stat.value_min }} - {{ stat.value_max }})</span>
                            </div>
                            
                            @if (stat.aggregation_type === 'average') {
                              <mat-progress-bar 
                                [value]="getProgressPercentage(stat)"
                                class="value-progress">
                              </mat-progress-bar>
                            }
                          </div>

                          @if (stat.last_updated) {
                            <div class="last-updated">
                              Last updated: {{ stat.last_updated | date:'short' }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  }
</div>
